import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "./commonSlice";
import { api } from "./services/baseApiSetup";

// ==================== CONFIGURATION SLICES ====================
import configurationSlice from "../Modules/configuration/configurationSlice.js";

// ==================== ADMINISTRATION SLICES ====================
import DataImportConfigSlice from "../Modules/configuration/admin/Schedulers/DataImportScheduler/DataImportSlice.js";
import EmailScheduleConfigSlice from "../Modules/configuration/admin/Schedulers/EmailScheduleConfiguration/EmailScheduleSlice";
import ToolsSlice from "../Modules/configuration/admin/tools/ToolsSlice.js";
import UserRoleMapSlice from "../Modules/configuration/admin/UserRoleMap/UserRoleMapSlice.js";
import LoginPageConfigSlice from "../Modules/configuration/admin/loginPageConfig/LoginPageConfigSlice.js";
import AssetOnboardingSlice from "../Modules/Inventory/AssetOnboarding/AssetOnboardingSlice.js";
import AssetApprovalSlice from "../Modules/Inventory/AssetApproval/AssetApprovalSlice.js";
import AssetScanSlice from "../Modules/Inventory/AssetScan/AssetScanSlice.js";

// ==================== CMDB SLICES ====================
import CMDBSlice from "../Modules/configuration/cmdb/cmdb-overview/CMDBSlice.js";

// ==================== HOME SLICES ====================
import Homeapislice from "../Modules/Home/HomeApiSlice.js";

// ==================== SETTINGS SLICES ====================
import AuditLogSlice from "../Modules/configuration/auditLog/AuditLogSlice.js";
import UserSessionSlice from "../Modules/configuration/userSessionLog/userSessionSlice.js";

export const store = configureStore({
  reducer: {
    // Base API
    [api.reducerPath]: api.reducer,

    // Common slices
    common: commonSlice,

    // ========== CONFIGURATION ==========
    configuration: configurationSlice,

    // ========== ADMINISTRATION ==========
    loginPageConfigAPI: LoginPageConfigSlice,
    toolsApi: ToolsSlice,
    userRoleMapAPI: UserRoleMapSlice,
    EmailSchduleConfiguration: EmailScheduleConfigSlice,
    DataImportConfig: DataImportConfigSlice,

    // ========== HOME ==========
    HomeApiCall: Homeapislice,

    // ========== CMDB ==========
    cmdbId: CMDBSlice,

    // ========== SETTINGS ==========
    AuditLogApi: AuditLogSlice,
    userSessionAPI: UserSessionSlice,

    // ========== SASSP Slices ==========
    AssetOnboardingAPI: AssetOnboardingSlice,
    AssetApprovalAPI: AssetApprovalSlice,
    AssetScanAPI: AssetScanSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware),
});
